import { showLoadingToast, closeToast, showToast } from 'vant'

export const toast = function ({ message = '', duration = 2000 }) {
  try {
    showToast({ message, duration })
  } catch (err) {
    console.log(err)
  }
}

export const loading = {
  show(text) {
    showLoadingToast({
      message: text || '加载中...',
      forbidClick: true,
      loadingType: 'spinner',
      duration: 0
    })
  },
  hide() {
    closeToast()
  }
}
